import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    SALES_BY_TEAM: "api/CRM/SalesReportByTeam",
    EXPORT_SALES_BY_TEAM: "api/CRM/Report/Sales/Team/Export",
    SALES_BY_CUSTOMER: "api/CRM/Report/Sales/ByCustomer",
    EXPORT_SALES_BY_CUSTOMER: "api/CRM/Report/Sales/ByCustomer/Export",
    SALES_BY_PRODUCT: "api/CRM/Report/Sales/ByProduct",
    EXPORT_SALES_BY_PRODUCT: "api/CRM/Report/Sales/ByProduct/Export",
    SALES_COVERAGE: "api/GetSalesCoverageReportByTeam",
    SALES_COVERAGE_BY_USERID: "api/GetSalesCoverageReportByUserId",
    EXPORT_SALES_COVERAGE_BY_USERID: "api/SalesCoverageByUserExport",
    EXPORT_SALES_cOVERAGE: "api/SalesCoverageExport",
    USER_SALES: "api/UserSales",
    EXPORT_USER_SALES: "api/UserSales/Export",
    UPLOAD_USER_SALES: "api/UserSales/Upload",
    SALES_BULK_REPORT: "api/CRM/Customer/BulkUpload/ShowFile",
    VIEW_BULK_REPORT_SALES: "api/UserSales/BulkUpload/ViewReport",
    EXPORT_SALES_BULK_REPORT: "api/UserSales/BulkUpload/ExportReport",
    DOWNLOAD_SALES_BULK_FILE: "api/UserSales/BulkUpload/ExportFile",
    VIEW_BULK_EXPORT: "api/UserSales/View/Export"
}

const getSalesByTeam = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.SALES_BY_TEAM, payload);
    return res.data;
};

const exportSalesByTeam = async (payload: any) => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPORT_SALES_BY_TEAM, { params: payload, responseType: "arraybuffer" });
    return res;
}

const getSalesByCustomer = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.SALES_BY_CUSTOMER, { params: payload });
    return res.data;
}

const exportSalesByCustomer = async (payload: any) => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPORT_SALES_BY_CUSTOMER, { params: payload, responseType: "arraybuffer" });
    return res;
}

const getSalesByProduct = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.SALES_BY_PRODUCT, { params: payload });
    return res.data;
}

const exportSalesByProduct = async (payload: any) => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPORT_SALES_BY_PRODUCT, { params: payload, responseType: "arraybuffer" });
    return res;
}

const getSalesCoverage = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.SALES_COVERAGE, payload);
    return res.data;
}

const getSalesCoverageByUserId = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.SALES_COVERAGE_BY_USERID, payload);
    return res.data;
}

const exportSalesCoverageByUserId = async (payload: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.EXPORT_SALES_COVERAGE_BY_USERID, payload, { responseType: "arraybuffer" });
    return res;
}

const exportSalesCoverage = async (payload: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.EXPORT_SALES_cOVERAGE, payload, { responseType: "arraybuffer" });
    return res;
}

const getUserSales = async (payload: { month: number; year: number }): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.USER_SALES, { params: payload });
    return res.data;
}

const exportUserSales = async (payload: { month: number; year: number }) => {
    const res = await privateRequest.get(ENDPOINTS.EXPORT_USER_SALES, { params: payload, responseType: "arraybuffer" });
    return res;
}

const uploadUserSales = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.UPLOAD_USER_SALES, payload);
    return res.data;
}

const getSalesBulkReport = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.SALES_BULK_REPORT, {
        params: { ...payload, loadtype: "UserSales" }
    });
    return res.data;
}

const viewBulkReportSales = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.VIEW_BULK_REPORT_SALES, {
        params: payload
    });
    return res.data;
}

const exportSalesBulkReport = async (fileId: number) => {
    const res = await privateRequest.get(`${ENDPOINTS.EXPORT_SALES_BULK_REPORT}/${fileId}`, {
        responseType: "arraybuffer"
    });
    return res;
}

const downloadSalesBulkFile = async (fileId: number) => {
    const res = await privateRequest.get(`${ENDPOINTS.DOWNLOAD_SALES_BULK_FILE}/${fileId}`, {
        responseType: "arraybuffer"
    });
    return res;
}

const exportSalesviewBulkReport = async (payload: any) => {
    const res = await privateRequest.post(ENDPOINTS.VIEW_BULK_EXPORT, null, {
        params: payload,
        responseType: "arraybuffer"
    });
    return res;
}

const SalesReportService = {
    getSalesByTeam,
    exportSalesByTeam,
    getSalesByCustomer,
    exportSalesByCustomer,
    getSalesByProduct,
    exportSalesByProduct,
    getSalesCoverage,
    getSalesCoverageByUserId,
    exportSalesCoverageByUserId,
    exportSalesCoverage,
    getUserSales,
    exportUserSales,
    uploadUserSales,
    getSalesBulkReport,
    viewBulkReportSales,
    exportSalesBulkReport,
    downloadSalesBulkFile,
    exportSalesviewBulkReport
};

export default SalesReportService;
